import moment from 'moment'

export default {
	// Inhalt des Modals
  model: {
    id: 0,
    name: '',
    area_id: 0,
    price: 0,
    description: '',

    forced: true
  },

  name: 'categories',

  validate () {
    this.model.price = parseFloat(this.model.price)
    return this.model.short_name.length <= 15
  },

	validateModel () {
		return true
	},

	copy (aModel) {
    this.model.id = aModel.id
    this.model.name = aModel.name
    this.model.price = aModel.price
    this.model.short_name = aModel.short_name

    this.model.forced = true
  },

	// Die Spalten für die Tabelle
  cols: [
    {
      name: 'Bezeichnung',
      json: 'name',
      type: 'text'
    },
    {
      name: 'Preis',
      json: 'price',
      type (aValue, aColumn, aModel) {
        return parseFloat(aValue) < 0 ? null : [parseFloat(aValue).formatMoney('', '.', ',', ' €')]
      },
      colStyle: 'text-align: right'
    },
    {
      name: 'Kürzel',
      json: 'short_name',
      type: 'text'
    }
  ],

  clear () {
    this.model.id = 0
    this.model.name = ''
    this.model.price = 0
    this.model.description = ''
    this.model.forced = true
  }
}



// WEBPACK FOOTER //
// ./src/models/categories.js